<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="title" width="600px" @close="close">
    <div slot="content">
      <el-form :model="formData" ref="vmManagementForm" class="mr-b30">
        <el-row type="flex" :gutter="15">
          <el-col :span="12">
            <el-form-item prop="mainVmUserId" label="사용자">
              <el-select style="width: 100%;" class="mr-r5 mr-b5" v-model="formData.mainVmUserId">
                <el-option v-for="(managerItem) in managerIdList" :label="`${managerItem.managerName} [${getValueAfterCheckEmpty(managerItem.managerId)}]`" :key="managerItem.managerId" :value="managerItem.managerId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="expireDate" label="만료날짜">
              <el-date-picker @change="onChangeDatePicker" v-model="formData.expireDate" type="date" placeholder="만료날짜를 선택해주세요" :picker-options="pickerOptions" value-format="timestamp"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row class="title-bar" type="flex">
        <div class="vertical-center-box title-h3">VM 정보</div>
      </el-row>
      <el-row class="mr-b30">
        <div class="list form-list">
          <el-form label-width="150px" label-position="left" :model="vmInfo">
            <el-form-item label="VM 명" prop="vmName">
              <el-input type="text" style="width: calc(100% - 69px)" v-model="vmInfo.vmName"></el-input>
            </el-form-item>
            <el-form-item label="CPU" prop="core">
              <el-input type="number" style="width: calc(100% - 69px)" v-model="vmInfo.core"></el-input>
              <span class="mr-4">개</span>
            </el-form-item>
            <el-form-item label="메모리" prop="memory">
              <el-input type="number" style="width: calc(100% - 69px)" v-model="vmInfo.memory"></el-input>
              <el-select style="width: 66px" v-model="vmInfo.memoryUnit">
                <el-option v-for="item in memoryUnitList" :key="item.label" :value="item.label" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="디스크" prop="disk">
              <el-input type="number" style="width: calc(100% - 69px)" v-model="vmInfo.disk"></el-input>
              <el-select style="width: 66px" v-model="vmInfo.diskUnit">
                <el-option v-for="item in diskUnitList" :key="item.label" :value="item.label" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
    </div>
    <el-row slot="footer" type="flex" justify="end">
      <el-button class="mr-r4" size="large" type="solid" @click="onSaveVmSetting">완료</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </el-row>
  </w-setting-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import { mapGetters } from 'vuex';
import DeviceRegistrationVmsAPI from '@/api/settings/common/device-registration-vms';
import MgrApi from '@/api/model/mgr';
import { cloneDeep, isEqual } from 'lodash';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';

export default {
  name: 'WVmManagementSettingPopup',
  data() {
    return {
      formData: {
        expireDate: '',
        mainVmUserId: '',
      },
      managerIdList: [],
      rowData: {},
      originVmInfo: null,
      vmInfo: {
        vmName: null,
        core: null,
        memory: null,
        disk: null,
        memoryUnit: 'MB',
        diskUnit: 'MB',
      },
      title: '',
      memoryUnitList: [
        { label: 'MB' },
        { label: 'GB' },
      ],
      diskUnitList: [
        { label: 'MB' },
        { label: 'GB' },
        { label: 'TB' },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },
  computed: mapGetters(['userInfo']),
  methods: {
    open(row, formData) {
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.title = `${row.vmName} 수정`;
        this.rowData = cloneDeep(row);
        this.formData = cloneDeep(formData);
        this.setVmInfo();
        this.loadData();
      });
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.initData();
    },
    loadData() {
      const params = {};
      MgrApi.getMgrList(params).then((res) => {
        if (res.data.success) {
          this.managerIdList = res.data.data;
          // 현재 로그인한 대상 삭제
          const targetIndex = this.managerIdList.findIndex((item) => item.managerId === this.userInfo.managerId);
          this.managerIdList.splice(targetIndex, 1);
        }
      });
    },
    initData() {
      this.formData = {
        expireData: '',
        mainVmUser: '',
      };
    },
    setVmInfo() {
      const rowData = cloneDeep(this.rowData);
      const memory = convertValuByUnit(rowData['VVM_MEM/TOTAL_CAPACITY'], 'MB', true, true, true);
      const memoryValue = memory.split(' ')[0];
      const memoryUnit = `${memory.split(' ')[1]}B`;
      const disk = convertValuByUnit(rowData['VVM_DISK/TOTAL_CAPACITY'], 'MB', true, true, true);
      const diskValue = disk.split(' ')[0];
      const diskUnit = `${disk.split(' ')[1]}B`;

      const vmInfo = {
        vmName: rowData.vmName,
        core: rowData['VVM_COMMON/CPU_CORE_TOTAL_COUNT'],
        memory: memoryValue,
        disk: diskValue,
        memoryUnit,
        diskUnit,
      };
      this.originVmInfo = cloneDeep(vmInfo);
      this.vmInfo = cloneDeep(vmInfo);
    },
    onSaveVmSetting() {
      const params = {
        vmsObjId: this.rowData.vmsObjId,
        ...this.formData,
      };
      if (!isEqual(this.originVmInfo, this.vmInfo)) {
        params.vmsParameterVo = this.rowData;
        params.vmInfo = this.vmInfo;
      }
      DeviceRegistrationVmsAPI.setVirtualVmSettingInfo(params).then((res) => {
        if (res.data.success) {
          this.$message(msgUtil.getCustomResultMsgData('저장하였습니다.', true));
          this.close();
          this.$emit('load-data');
        } else {
          this.$message(msgUtil.getCustomResultMsgData('저장하지 못하였습니다.', false));
        }
      });
    },
    onChangeDatePicker(date) {
      this.formData.expireDate = date;
    },
    getValueAfterCheckEmpty(value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Virtual/popup/VmManagementSettingPopup.vue